import React, { useState, useEffect } from "react";
import moment from "moment";
import { downArrow } from "../assets/icons";
import { ImgIcon } from "../assets";
import { splitTime, timeSlots } from "../helpers";

export default function EtaSelector({ onChange, value }) {

    const [date, setDate] = useState(moment(value || undefined));

    useEffect(() => {
        setDate(moment(value || undefined))
    }, [value])

    const isToday = date.isSame(moment(), 'day');

    return <div className="etaSelector noSelect">
        <div className="date">
            <div
                className={`arrow left ${isToday ? 'disabled' : ''}`}
                onClick={() => {
                    if (!isToday) setDate(date.clone().subtract(1, 'days'))
                }}
            >
                <ImgIcon
                    style={isToday ? { opacity: "0.2" } : {}}
                    cursor={isToday ? "initial" : "pointer"}
                    size={26}
                    src={downArrow}
                />

            </div>
            <div className="current-day featureFont upperCase">{isToday ? "Today" : date.format("ddd Do MMMM")}</div>
            <div
                className="arrow right"
                onClick={() => {
                    setDate(date.clone().add(1, 'day'))
                }}
            >
                <ImgIcon
                    cursor="pointer"
                    size={26}
                    src={downArrow}
                />
            </div>
        </div>
        <div className="times">
            {timeSlots.map(slot => {

                let time = splitTime(slot);
                let value = date.clone().set({ hour: time[0], minute: time[1] });
                if (isToday & value.isBefore(moment())) return null;

                return <div
                    key={slot}
                    onClick={() => {
                        setDate(value.clone());
                        onChange(value.clone());
                    }}
                    className={`slot ${date.isSame(value) ? 'selected' : ''}`}
                >
                    <span>{slot}</span>
                    <span className="circle"></span>
                </div>
            })}
        </div>
    </div>
}
